module.exports = __webpack_public_path__ + "img/play.cabc3666.svg";